module.exports = __webpack_public_path__ + "img/glocal-ai-icon-navbar-black.9b187f69.svg";